<script>
    import Arts from './arts/Arts.vue'
    import KSKeysDragDrop from './keys/KSKeysDragDrop.vue'
    import KeywordsFieldDefs from './keys/KeywordsFieldDefs'
    import KSClusterBreadCrumbs from './KSClusterBreadCrumbs.vue'
    import ClusterKeysAction from '../../../component/ks-table/component/cluster-keys-action.vue'
    import {doLangFields, isGoogleGny} from '../../../lib/ks-tools'
    import KeywordsGny from "./keys/KeywordsGny";
    import {Listeners} from "../../../constants/listeners";
    import {store} from "../store";
    import KSFilter from "../../../component/ks-filter/KSFilter.vue";
    import KSTable from "../../../component/ks-table/KSTable.vue";

    export default {
        name: "KSClusterEdit",
        data() {
            return {
                keywordsFields: doLangFields(this, "lang.cluster.fields", isGoogleGny() ? KeywordsGny : KeywordsFieldDefs),
                keywordsSortOrder: [
                    {
                        field: window.report_db.engine === "yandex" ? 'superwsk' : 'ws',
                        direction: 'desc'
                    }
                ],
                additionalActions: [
                    {
                        label: this.$t('lang.cluster.create_grp_by_cur_flt'),
                        icon: ["fa", "fa-object-group"],
                        event: function(){
                            this.$emitter.emit(Listeners.CLUSTER_CREATE_NODE_FROM_FILTER, {
                                filter: this.getQuery(),
                                selectedTo: this.$parent.$refs.ksTable.$refs.vuetable.selectedTo
                            });
                        }
                    },
                    {
                        label: this.$t('lang.main.table.components.cluster_keys.move_another_folder'),
                        icon: ["fa", "fa-exchange"],
                        event: function(){
                            this.$emitter.emit(Listeners.CLUSTER_MOVE_KEYS_FROM_FILTER, {
                                filter: this.getQuery(),
                                allSelected: this.$parent.$refs.ksTable.$refs.vuetable.allSelected,
                                selectedTo: this.$parent.$refs.ksTable.$refs.vuetable.selectedTo
                            });
                        }
                    },
                ],
                tableApi: null,
                store: store,
            }
        },
        props: ["isAuthorized", 'setting'],
        methods: {
            toggleTableRow(row){
                const vuetable = this.$refs.ksTable.$refs.vuetable;

                if (vuetable.selectedTo.indexOf(row.id) === -1) {
                    vuetable.selectId(row.id);
                } else {
                    vuetable.unselectId(row.id);
                }

                // unselectId создаёт новый массив — синхронизируем, как при onCheckboxToggled
                this.$refs.ksTable.selectedTo = vuetable.selectedTo;
            },
        },
        computed: {
            getUid() {
                return this.store.getters.uid();
            },
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            showTable() {
                return Object.keys(this.getSelectNode).length > 0 && this.getSelectNode.id !== 0;
            },
        },
        watch: {
            getSelectNode() {
                // у «Все папки» таблицы нет: фильтр и таблица только скрываются, а не пересоздаются,
                // иначе при возврате в папку строка поиска окажется пустой при отфильтрованном дереве
                if (!this.showTable) {
                    return;
                }

                this.tableApi = '/clustering/node/' + this.getUid + "/" + this.getSelectNode.id + "/keywords";
            }
        },
        components: {
            Arts,
            'ks-breadcrumbs': KSClusterBreadCrumbs,
            ClusterKeysAction,
            'ks-keys-drag-drop': KSKeysDragDrop,
            'ks-filter': KSFilter,
            'ks-table': KSTable,
        },
        mounted () {
            this.store.mutations.setSetting(this.setting);
        },
    }
</script>
<template>
    <div class="row">
        <div class="col-sm-4 filter overflow-auto" id="tour-step-8">
            <Arts />
        </div>

        <div class="col-sm-8 filter" ref="right-panel" style="padding-top: 2px;" id="tour-step-13">
            <ks-breadcrumbs />

            <ks-filter :fields="keywordsFields" ref="filter" report-name="clusters" :additional-actions="additionalActions" :is-copy="true"
                       :is-authorized="isAuthorized" v-if="tableApi" v-show="showTable" :is-download="true" :is-info="false"
            >
            </ks-filter>

            <ks-table
                    ref="ksTable"
                    :fields="keywordsFields"
                    :sort-order="keywordsSortOrder"
                    :api-url="tableApi"
                    :use-async-csv-export="false"
                    v-if="tableApi"
                    v-show="showTable"
                    :enabled-animate="false"
                    :on-row-clicked="toggleTableRow"
            ></ks-table>
            <cluster-keys-action/>

            <div v-if="!showTable">

                <div style="text-align: center; margin-top: 15%; color: #eee;"><i class="fa fa-table" aria-hidden="true" style="font-size: 400px;"></i></div>

            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
